import SliderViewSection from "../../components/SliderViewSection";
import {
    slideImg,
    RiskPolicyTrackingRemoteIcon,
    RegulatoryComplianceRemoteIcon,
    GovernanceVisibilityRemoteIcon,
    ESGReportingIntelligenceRemoteIcon,
    EnterpriseAccountabilityRemoteIcon,
    AutomatedAuditRemoteIcon,
    Component10,
    Component11,
    Component12,
    Component13,
    Component14,
    Component15,
} from "../../constant";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import SolutionFourCardSwapSection from "../../components/SolutionFourCardSwapSection";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import GraphViewSection from "../../components/GraphViewSection";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import RemoteAccessLanding from "../../components/Solution/RemoteAccessLanding";
import TogetherSection from "../../components/Solution/TogetherChange";

const slidesData = [
    {
        viewData: [
            {
                imgUrl: [Component11],
            },
            {
                imgUrl: [Component12],
            },

            {
                imgUrl: [Component15],
            },
            {
                imgUrl: [Component10],
            },
            {
                imgUrl: [Component14],
            },
            {
                imgUrl: [Component13],
            },
            
        ],










        menuItems: [{
            title: "Equipment Health",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Production Analytics",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Process Parameters",
            Icons: DashboardOutlinedIcon,
        },
        {
            title: "RTU Monitoring ",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Maintenance Planning ",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Alarms & Exceptions",
            Icons: InsertChartOutlinedIcon,
        }
        ],
    }


];



const AnimatedCardCrausalData = [
    {
        icon: RegulatoryComplianceRemoteIcon,
        title: "Regulatory Compliance",
        description:
            "Ensure adherence to ESG mandates, statutory regulations and enterprise compliance frameworks through centralized monitoring and reporting.",
    },
    {
        icon: AutomatedAuditRemoteIcon,
        title: "Automated Audit Workflows",
        description:
            "Digitize audits, inspections and approvals with intelligent workflows, automated reminders and escalation mechanisms.",
    },
    {
        icon: GovernanceVisibilityRemoteIcon,
        title: "Governance Visibility",
        description: "Gain real-time visibility into policies, certifications, obligations and compliance performance across operations.",
    },
    {
        icon: RiskPolicyTrackingRemoteIcon,
        title: "Risk & Policy Tracking",
        description: "Continuously monitor regulatory risks, policy deviations and non-conformances with actionable alerts and analytics.",
    },
    {
        icon: ESGReportingIntelligenceRemoteIcon,
        title: "ESG Reporting Intelligence",
        description: "Simplify sustainability and ESG disclosures with automated data consolidation, traceability and reporting insights.",
    },
    {
        icon: EnterpriseAccountabilityRemoteIcon,
        title: "Enterprise-Wide Accountability",
        description: "Enable cross-functional collaboration with role-based access, centralized documentation and transparent governance processes. ",
    }

];

const FourCardsSwapcardData = [
    {
        title: "Asset Performance",
        description:
            "Monitor the real-time location, status, and operational health of industrial assets across plants, mines, utilities, and remote facilities through connected IoT-enabled systems.",
    },
    {
        title: "Resource Optimization ",
        description: "Improve productivity by analyzing equipment utilization, manpower deployment, energy consumption, and operational bottlenecks to maximize efficiency and reduce idle time. "
    },

    {
        title: "Project Performance Intelligence",
        description:
            "Track project execution effectiveness using CPI (Cost Performance Index) and SPI (Schedule Performance Index) metrics to identify delays, cost overruns, and productivity deviations in real time, enabling proactive corrective actions and better project governance.",
    },
];
const tabsData = [
    {
        label: "About iED",
        key: "1",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Mission",
        key: "2",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Leadership",
        key: "3",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Differentiators",
        key: "4",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Technology",
        key: "5",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
];


export default function RemoteAccessMonitoring() {
    return (
        <>
            <RemoteAccessLanding />
            <SolutionFourCardSwapSection
                title={"Key Features Powering Remote Asset Intelligence"}
                subTitle={"Gain real-time operational visibility, improve execution efficiency, and optimize project outcomes through intelligent monitoring and data-driven operational insights. Our platform enables organizations to remotely manage industrial assets, field activities, and project performance from a centralized control environment."}
                cardData={FourCardsSwapcardData}
            />
            <GraphViewSection
                title={"The Power of Centralized Operational Dashboards"}
                subTitle={"Our centralized dashboards provide a unified view of industrial operations, enabling organizations to monitor performance, compliance, safety, maintenance, and project execution from a single intelligent platform. Transform fragmented operational data into actionable insights for faster and more informed decision-making."}
                data={slidesData}
            />
            <AnimatedCardCrausal
                title={"Essential Drivers of Compliance Excellence"}
                subTitle={"Explore intelligent governance solutions designed to simplify enterprise compliance and ESG management. From automated audit workflows to real-time policy tracking, empower teams with centralized visibility, proactive alerts and data-driven compliance intelligence."}
                data={AnimatedCardCrausalData}
            />
            <WeAreIED solution={true} />
            <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
            <AnimatedCardCrausal />
            <TogetherSection title={"Unlock the Future of Intelligent Operations"}
                subTitle={"Transform enterprise operations with connected digital solutions that enhance visibility, optimize performance and accelerate sustainable growth across assets and infrastructure."} />

            <ContactUs />
            <StayInLoop />
        </>
    );
}
